var AT_Main = {

  getWidthBrowser : function() { // Get width browser
    var myWidth;

    if( typeof( window.innerWidth ) == 'number' ) {
      //Non-IE
      myWidth = window.innerWidth;
    }
    else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
      //IE 6+ in 'standards compliant mode'
      myWidth = document.documentElement.clientWidth;
    }
    else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
      //IE 4 compatible
      myWidth = document.body.clientWidth;
    }

    return myWidth;
  }
 
  ,checkLayout : function() { // Function to check level of layout
    if(jQuery("#checkLayout .d-block").css("display") == "block")
      return 0; //smallest layout
    else if(jQuery("#checkLayout .d-sm-block").css("display") == "block")
      return 1; //mobile layout
    else if(jQuery("#checkLayout .d-md-block").css("display") == "block")
      return 2; //tablet potrait layout
    else if(jQuery("#checkLayout .d-lg-block").css("display") == "block")
      return 3; //tablet landscape/medium desktop layout
    else if(jQuery("#checkLayout .d-xl-block").css("display") == "block")
      return 4; //desktop layout
  }

  ,homeSlideshow : function(){
    var _delay_time = '';
    jQuery('.home-slideshow-wrapper').each(function(){
      var id = $(this).data('id');

      if(jQuery('.swiper-container-'+id).data('autoplay')){
        _delay_time = jQuery('.swiper-container-'+id).data('time');
      }

      var swiper = new Swiper('.swiper-container-'+id, {
        autoplay: _delay_time
        ,loop: true
        ,simulateTouch:true
        ,pagination: '.slideshow-'+id+' .swiper-pagination'
        ,paginationClickable: '.slideshow-'+id+' .swiper-pagination'
        ,nextButton: '.slideshow-'+id+' .swiper-button-next'
        ,prevButton: '.slideshow-'+id+' .swiper-button-prev'
        ,spaceBetween: 30
        ,scrollbarDraggable: true
        ,effect: jQuery('.swiper-container-'+id).data('animation')
        ,cube: {shadow: false}
        ,setWrapperSize: false
        ,onImagesReady: function(swiper){
          $(swiper.container[0]).find('.swiper-slide img').css('visibility','visible');
          $(swiper.container[0]).find('.swiper-slide').each(function(){
            var _this = $(this);
            _this.find('.video-slide').show();
            if (!_this.find('.video-slide').data('full-height')) {
              _this.find('.video-slide video').css({
                position: 'relative',
                width: '100%'
              });
            }
            else{
              _this.find('.video-slide video').css({
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
              });
            }
          });
          jQuery('.swiper-container-'+id).data('parallax') && AT_Main.parallaxScroll(jQuery('.swiper-container-'+id),jQuery('.swiper-container-'+id).find('.swiper-slide'));
          var el = jQuery('.slideshow-'+id);
          if(el.data('adapt')){
            var min_height = el.width() / el.data('min-aspect-ratio');
            el.height(min_height);
            jQuery('.swiper-container-'+id).height(min_height);
            el.find('span.image--style').css('padding-top', min_height+'px');

            jQuery(window).resize(function(){
              var min_height = el.width() / el.data('min-aspect-ratio');
              el.height(min_height);
              jQuery('.swiper-container-'+id).height(min_height);
              el.find('span.image--style').css('padding-top', min_height+'px');
            });
          }
        }
      });
    })
  }
  ,homeIE : function(){
   var _delay_time = ''; 
   jQuery('.home-slideshow-wrapper').each(function(){
    var id = $(this).data('id');
    if(jQuery('.swiper-container-'+id).data('autoplay')){
      _delay_time = jQuery('.swiper-container-'+id).data('time');
    }

    var swiper = new Swiper('.swiper-container-'+id, {
      autoplay: _delay_time
      ,loop: true
      ,simulateTouch:true
      ,pagination: '.slideshow-'+id+' .swiper-pagination'
      ,paginationClickable: '.slideshow-'+id+' .swiper-pagination'
      ,nextButton: '.slideshow-'+id+' .swiper-button-next'
      ,prevButton: '.slideshow-'+id+' .swiper-button-prev'
      ,spaceBetween: 30
      ,scrollbarDraggable: true
      ,effect: 'fade'
      ,setWrapperSize: true
      ,onImagesReady: function(swiper){
        $(swiper.container[0]).find('.swiper-slide img').css('visibility','visible');
        $(swiper.container[0]).find('.swiper-slide').each(function(){
          var _this = $(this);
          _this.find('.video-slide').show();
          if (!_this.find('.video-slide').data('full-height')) {
            _this.find('.video-slide video').css({
              position: 'relative',
              width: '100%'
            });
          }
          else{
            _this.find('.video-slide video').css({
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)'
            });
          }
        });
        var el = jQuery('.slideshow-'+id);
        if(el.data('adapt')){
          var min_height = el.find('.bc-wrapper').width() / el.data('min-aspect-ratio');
          el.height(min_height);
          jQuery('.swiper-container-'+id).height(min_height);
          jQuery(window).resize(function(){
            var min_height = el.find('.bc-wrapper').width() / el.data('min-aspect-ratio');
            el.height(min_height);
            jQuery('.swiper-container-'+id).height(min_height);
          });
        }
      }
    });
  })
  }


,stickAddToCart : function() {
  $(window).on( 'scroll' , function() {
    var ps = jQuery(this).scrollTop();
    var _show_sticky = ($('#add-to-cart').offset().top);

    if ( _show_sticky < ps ) {
      $('.add-to-cart-sticky').addClass('show');
      $('#footer-content').css('margin-bottom', $('.add-to-cart-sticky')[0].clientHeight);
    }
    else {
      $('.add-to-cart-sticky').removeClass('show');
      $('#footer-content').removeAttr('style');
    }
  });
}
,toTopButton : function(){
  var to_top_btn = $("#scroll-to-top");
  if( 1 > to_top_btn.length ){
    return;
  }
  $(window).on( 'scroll' , function() {
    var b = jQuery(this).scrollTop();
    var c = jQuery(this).height();
    if (b > 100) {
      var d = b + c / 2;
    }
    else {
      var d = 1 ;
    }

    if (d < 1000 && d < c) {
      jQuery("#scroll-to-top").removeClass('on off').addClass('off');
    } else {
      jQuery("#scroll-to-top").removeClass('on off').addClass('on');
    }
  });

  to_top_btn.on( 'click',function (e) {
    e.preventDefault();
    jQuery('body,html').animate({scrollTop:0},800,'swing');
  });
}

  ,toggleCartSidebar : function(){
    jQuery('.cart-toggle').on('click',function (e) {
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery('.cart-sb').toggleClass('opened');
      jQuery('body').toggleClass('cart-opened');
    });

    jQuery('#page-body, .c-close').on('click',function () {
      jQuery('.cart-sb').removeClass('opened');
      jQuery('html,body').removeClass('cart-opened');
      jQuery(".dropdown").removeClass("menu-mobile-open");
      AT_Main.fixReturnScroll();
    });

    jQuery('.am-close').on('click',function (e) {
      jQuery('.layer-addcart-modal').removeClass('show');
    });
  }

  ,toggleFilterSidebar : function(){
    jQuery(document).on('click','.filter-icon.toggle',function (e) {
      jQuery('.filter-component').slideToggle("slow");
    });
    jQuery(document).on('click','.filter-icon.drawer',function (e) {
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery('body').toggleClass('sidebar-opened');
    });

    jQuery('#page-body').on('click',function () {
      if (jQuery('html,body').hasClass('sidebar-opened') || jQuery('html,body').hasClass('order-sidebar-opened')) {
        jQuery('html,body').removeClass('sidebar-opened order-sidebar-opened');
        AT_Main.fixReturnScroll();
      }
    });

    jQuery('.f-close').on('click',function () {
      jQuery('#sidebar').removeClass('opened');
      jQuery('html,body').removeClass('sidebar-opened');
      AT_Main.fixReturnScroll();
    });

    jQuery('.filter-icon-order').on('click',function (e) {
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery('body').toggleClass('order-sidebar-opened');
    });

    jQuery('.fof-close').on('click',function () {
      jQuery('html,body').removeClass('order-sidebar-opened');
      AT_Main.fixReturnScroll();
    });
  }

  ,cart_event_handle : function(){
    AT_Main.cartMobile();

    jQuery(document).on('click','.layer-addcart-wrapper',function(e){
      let c = e.target.className;
      if (c == 'layer-addcart-modal show' || c == 'layer-addcart-wrapper'){
        jQuery('.am-close').trigger('click');
      }
    });
  }
  ,cartMobile : function(){
    if (jQuery('body').hasClass('templateCart') && AT_Main.getWidthBrowser() < 768 && jQuery('.mobile-fixed').length) {
      let e = jQuery('.mobile-fixed'), top = 200;
      if (typeof e != 'undefined') {
        jQuery(window).on('scroll' , function() { jQuery(window).scrollTop() < top ? e.removeClass('sticky') : e.addClass('sticky')})
      }
    }
  }

  ,handleGridList : function(){
    AT_Main.handleGridList_Remove();

    let num = $('.cata-toolbar').data('grid-col');
      el = $(".templateCollection .mode-view-item");

    if($.cookie('mode-view') == 'list'){
      $(".mode-view-item").addClass("products-list-item");
      $(".mode-view-item").addClass('number-1');
      $(".grid-list .list").addClass("active");
      el.find('.product-content').addClass('hide');
      el.find('.product-list-content').removeClass('hide');
    }else{
      $(".mode-view-item").addClass("products-grid-item");
      $(".mode-view-item").addClass('number-'+num);
      el.find('.product-list-content').addClass('hide');
      el.find('.product-content').removeClass('hide');
      $(".grid-list .grid").addClass("active");
    }
    setTimeout(function(){
      $(".mode-view-item").removeClass('loading');
    },500);

    jQuery(document).on("click", ".grid", function() {
      AT_Main.handleGridList_Remove();
      $.cookie('mode-view','grid',  {expires: 1, path: '/'});

      $(".mode-view-item").addClass("products-grid-item");
      $(".mode-view-item").addClass('number-'+num);
      el.find('.product-list-content').addClass('hide');
      el.find('.product-content').removeClass('hide');
      $(".grid-list .grid").addClass("active");
    })

    jQuery(document).on("click", ".list", function() {
      AT_Main.handleGridList_Remove();
      $.cookie('mode-view','list',  {expires: 1, path: '/'});

      $(".mode-view-item").addClass("products-list-item");
      $(".mode-view-item").addClass('number-1');
      el.find('.product-content').addClass('hide');
      el.find('.product-list-content').removeClass('hide');
      $(".grid-list .list").addClass("active");
    })
  }

  ,handleGridList_Remove : function(){
    jQuery('.mode-view-item').removeClass('number-1 number-3 number-4 number-5 products-grid-item products-list-item');
    $(".grid-list .grid, .grid-list .list").removeClass("active");
  }
  ,handleOrderFormQty : function(){
    jQuery("body").on("click",".global-product-info-qty-plus",function(){
      q = $(this).prev();
      var value = parseInt(q.val(), 10);
      value = isNaN(value) ? 0 : value;
      value++;
      q.val(value);
    });

    jQuery("body").on("click",".global-product-info-qty-minus",function(){
      q = $(this).next();
      var value = parseInt(q.val(), 10);
      value = isNaN(value) ? 1 : value;
      if(value > 0){
        value--;
        q.val(value);
      }
    });
  }

  ,effectNavigation : function(){ // Make hover effect of navigation

    jQuery(".top-account-holder").hover(function(e){
      jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
    },function(e){
      jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
    });

    jQuery(".currency-block").hover(function(e){
      jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
    },function(e){
      jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
    });

    jQuery(document).on('click','.searchbox>a',function(e){
      $(this).parents().find('.searchbox').toggleClass('open');
      $('#page-body').trigger('click');
    });

    jQuery('#city-phone-numbers').on("change", function(e) {
      var _newcity = jQuery(e.currentTarget).find(':selected').attr('value');
      $('#city-phone-number-label').html(_newcity);
    });

  }

  ,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
    var windowW = jQuery(window).width();
    jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
  }

  ,fixReturnScroll : function() {
    jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', '');
    let body = jQuery('body');
    body.removeClass('menu-opened').css('padding-right',0).attr('style', body.attr('style').replace('padding-right: 0px;', ''));
    body.attr('style').length == 0 && body.removeAttr('style');
  }

  ,fixButton : function(){
    jQuery(".product-wrapper .product-head").each(function(e){
      if($(this).children().hasClass('wrapper-countdown')){
        $(this).find('.product-button').addClass('fix');
      }
    });
  }

  ,handleReviews: function() {
    if (typeof SPR != 'undefined') {
      SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
    }
  }

  ,menuOnMobile : function(){
    jQuery('#page-body, .show-compare').on('click',function (e) {
      if (jQuery(".menu-mobile").hasClass('opened') ) {
        jQuery(".menu-mobile").removeClass("opened");
        jQuery("html,body").removeClass("menu-opened");
        AT_Main.fixReturnScroll();
      }
    });

    jQuery('.mm-block-icons .wishlist-target, .mm-block-icons .compare-target, .m-close').on('click',function () {
      jQuery(".menu-mobile").removeClass("opened");
      jQuery("html,body").removeClass("menu-opened");
      AT_Main.fixReturnScroll();
    });

    jQuery(document).on('click','#responsive-menu-mobile',function(e){
      //e.stopPropagation();
      jQuery(".menu-mobile").hasClass("opened") ? AT_Main.fixReturnScroll() : AT_Main.fixNoScroll();
      jQuery(".menu-mobile").toggleClass("opened");
      jQuery('body').addClass('menu-opened');
      //jQuery("html,body").toggleClass("menu-opened")

    });

    jQuery(document).on('click','.ham-desk .responsive-menu',function(e){
      //e.stopPropagation();
      var elem = $(this).parent().find('.menu-on-hover');
      if (elem.hasClass('opened')) {
        $(this).parent().removeClass('opened');
        elem.removeClass('opened');
      }
      else{
        $(this).parent().addClass('opened');
        elem.addClass('opened');
      }
    });

    jQuery(".navbar .main-nav li").hover(function(){
      if (!jQuery(this).parents('.mobile-version')){
        jQuery(this).addClass("hover")
      }
    },function(){
      jQuery(this).removeClass("hover")}
      );

    jQuery(document).on('click','.bc-toggle',function(){

      var e=jQuery(this);
      if (e.hasClass("opened")) {
        e.removeClass("opened");
      } else {
        e.addClass("opened");
      }
    });

    jQuery(document).on('click','.top-cart-holder.hover-dropdown .cart-target',function(){
      var e=jQuery(this);
      e.hasClass("opened") ? e.removeClass("opened") : e.addClass("opened");
    });

  }

  ,handleMenuMultiLine : function() {
    var outItem = "";
    var down = false;

    var top = 0;

    jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
      var target = jQuery(e.currentTarget);

      if( down && outItem != "") {
        outItem.addClass("hold");
        setTimeout(function(){
          if(outItem != "")
            outItem.removeClass("hold");
          down = false;
          outItem = "";
        },500);

        if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
        {
          outItem.removeClass("hold");
          down = false;
          outItem = "";
        }
      }
      else {
        outItem = "";
      }

    });

    jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

      var target = jQuery(e.currentTarget);

      if( e.pageY >= target.offset().top + 50 ) { //move down
        down = true;
      }

      if( target.hasClass("dropdown") ) { //target has child

        if(outItem == "")
          outItem = target;
      }

    });
  }


  ,fixTitle : function(){ // fix title a in filter & swatch size in detail product page
    jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
    jQuery(".rt a, .tags-prd").removeAttr("title");
  }

  ,filterCatalogReplace : function(collectionUrl, filter_id){

    var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
    var val = value.substring(value.lastIndexOf('?'));

    collectionUrl = collectionUrl.replace(value, '');

    value = value.replace(val, '');
    value = value.replace('#', '');

    var value_arr = value.split('+');

    var current_arr = [];
    jQuery('#'+filter_id+' li.active-filter').each( function() {
      current_arr.push(jQuery(this).attr('data-handle'));
    });

    jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
    jQuery('#'+filter_id+' li').removeClass('active-filter');

    for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
      value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
    }

    var new_data = value_arr.join('+')

    var new_url = collectionUrl+new_data+val;

    if( typeof AT_Filter != 'undefined' && AT_Filter ){
      AT_Filter.updateURL = true;
      AT_Filter.requestPage(new_url);
    }else{
      window.location = new_url;
    }

  }
  ,filterCatalog_AccordionHandle : function(){
    let filters = jQuery('.advanced-filter');
    if(filters.parents('.accordion').length > 0){
      $('.advanced-filters').each(function () {
        let parent = $(this);

        let active = false;
        parent.children('.advanced-filter').each(function(){
          if ($(this).hasClass('active-filter')) {
            active = true;
          }
        })

        if (active) {
          parent.parent().addClass('active del-before');
        }else{
          parent.parent().removeClass('active del-before');
        }
      })
    }
  }

  ,filterCatalog : function(){
    var currentTags = ''
    ,filters  = jQuery('.advanced-filter');

    filters.each(function() {
      var el = jQuery(this)
      ,group = el.data('group');

      if ( el.hasClass('active-filter') ) { //Remove class hidden
        el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
        jQuery('#clear-all-filter').removeClass('hidden');

        el.parents('.sbw-filter.select').addClass('has-active').find('.advanced-filters').addClass('has-active');
      }
    });
    $('.advanced-tag-filter').each(function() {
      var el = jQuery(this)
      ,group = el.data('group');

      if ( el.hasClass('active-filter') ) { //Remove class hidden
        el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
        jQuery('#clear-all-filter').removeClass('hidden');
      }
    });
    AT_Main.filterCatalog_AccordionHandle();

    filters.on('click', function(e) {
      var el = $(this)
      ,group = el.data('group')
      ,url = el.find('a').attr('href')

        // Continue as normal if we're clicking on the active link
        if ( el.hasClass('active-filter') ) {
          return;
        }
        jQuery(this).parents('.sbw-filter').first().addClass('waiting');
        AT_Main.filterCatalog_AccordionHandle();

        var _logic = jQuery(".page-cata").data('logic');
        if( _logic ){
            // Get active group link (unidentified if there isn't one)
            activeTag = $('.active-filter[data-group="'+ group +'"]');
            // If a tag from this group is already selected, remove it from the new tag's URL and continue
            if ( activeTag && activeTag.data('group') === group ) {
              e.preventDefault();
              activeHandle = activeTag.data('handle') + '+';

              // Create new URL without the currently active handle
              url = url.replace(activeHandle, '');

              // window.location = url;
              AT_Filter.updateURL = true;
              AT_Filter.requestPage(url);
            }
          }
        });

    jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear
      n.preventDefault();

      var filter_id = jQuery(this).attr('id');
      filter_id = filter_id.replace('clear-', '');
      jQuery(this).parents('.sbw-filter').first().addClass('waiting');
      jQuery(this).parents('.sbw-filter.select').removeClass('has-active').find('.advanced-filters').removeClass('has-active');
      var collectionUrl = window.location.href;
      if(collectionUrl.match(/\?/)){
        var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

        if(string.match(/\//)){
          var str_replace = string.replace(/\//, '');
          collectionUrl = collectionUrl.replace(string, '');
          collectionUrl = collectionUrl+str_replace;
          AT_Main.filterCatalogReplace(collectionUrl, filter_id);
        }
        else{
          AT_Main.filterCatalogReplace(collectionUrl, filter_id);
        }
      }
      else{
        var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
        collectionUrl = collectionUrl.substring(0,collectionUrl.lastIndexOf('/') + 1);
        value = value.replace('#', '');

        var value_arr = value.split('+');
        var current_arr = [];
        jQuery('#'+filter_id+' li.active-filter').each( function() {
          current_arr.push(jQuery(this).attr('data-handle'));
        });

        jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
        jQuery('#'+filter_id+' li').removeClass('active-filter');

        for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
          value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
        }

        var new_data = value_arr.join('+')
        if ($(this).parents('.sb-filter').hasClass('tag')) {
          window.location.href = collectionUrl;
        }else{
          var new_url = collectionUrl+new_data;
          if( typeof AT_Filter != 'undefined' && AT_Filter ){
            AT_Filter.updateURL = true;
            AT_Filter.requestPage(new_url);
          }else{
            window.location = new_url;
          }
        }

      }

    });

  }
  ,sidebar_menu_handle : function(){// Handle menu sidebar
    jQuery(document).on('click','.categories-menu .dropdown .expand, .sidebar-column .sb-filter',function(e){
      if ($(this).hasClass('active') && !$(this).hasClass('del-before')){
        $(this).removeClass('active');
        $(this).parent().removeClass('active');
      }else{
        $(this).parent().children().each(function(){
          if (!$(this).hasClass('del-before')) {
            $(this).removeClass('active');
          }
        })
        $(this).addClass('active');
        $(this).parent().addClass('active');
      }
    })

    $('.grid-uniform').length && $('.grid-uniform').each(function(){
      $(this).find('.advanced-filters').children().length == 0 && $(this).parents('.sb-widget').remove();
    });

    $(document).on('click','.sb-accordion',function(e){
      $(this).toggleClass('active').parent().find('.sb-content-accordion').toggleClass('hide');
    });
    
  }
  ,swatch : function(){
    jQuery('.swatch :radio').change(function() {
      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
      var optionValue = jQuery(this).val();
      jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');

    });
  }

  ,switchImgProduct: function() {
    $(document).on('click','.product-wrapper .swatch-element',function(){
      $(this).parents('.swatch').find('.swatch-element[data-value]').removeClass('active');
      $(this).addClass('active');
      var elem = $(this).find('label').first();
      var imgUrl = elem.data("swatch-image"),
      parent = elem.parents('.product-wrapper'),
      imgElem = parent.find('.product-image img').first();
      var _v = elem;
      if(imgElem.hasClass('lazyloaded')){
        var _img = _v.parent().find('.img-swt-temp');
        imgElem.attr('data-srcset',_img.attr('data-srcset'));
        imgElem.attr('srcset',_img.attr('srcset'));
      }else{
        imgElem.attr('src', imgUrl);
      };
    });

    $('.product-wrapper .swatch-element').hover(function(e){
      $(this).trigger('click');
    });
  }


  ,scareWidth : function(){
    var _name_width = 110;
    jQuery('.variants-wrapper .selector-wrapper').find('label').each(function( index,value ){
      _name_width = jQuery(value).width() > _name_width ? jQuery(value).outerWidth() : _name_width;
    });
    jQuery('.product-code span:first-child').css('width',_name_width);
    jQuery('.product-qty, .quantity').find('label').css('width',_name_width);

    jQuery('.variants-wrapper .selector-wrapper').find('label').css('width','70px');
    jQuery('.swatch.color, .swatch.colour').find('.header').css('width','100%');
    jQuery('.swatch.size').find('.header').css('width','100%');

  }

  ,scareName : function(){
    var _name_height = 0;
    jQuery('.product-wrapper').find('h5.product-name').each(function( index,value ){
      _name_height = jQuery(value).outerHeight() > _name_height ? jQuery(value).outerHeight() : _name_height;
    });
    jQuery('.product-wrapper').find('h5.product-name').css('height',_name_height);
  }
  ,scareScreen : function(){
    if( typeof _bc_config == "undefined" ){
      return;
    }
    var _current = this;

    if( _bc_config.enable_title_blance == "true" ){
      this.scareName();
    }

    jQuery( document ).ajaxComplete(function( event,request, settings ) {
      if( _bc_config.enable_title_blance == "true" ){
        _current.scareName();
      }
    });
  }


  ,parallaxScroll : function(e,p){
    if (typeof e != 'undefined' || typeof p != 'undefined') {
      jQuery(window).on('scroll.parallax', function(){
        var pos = jQuery(window).scrollTop();
        var elem = e;//jQuery('.slideshow-catalog-wrapper');
        var top = elem.offset().top;
        var elemH = elem.height();
        var windowHeight = jQuery(window).height();
        var param =  p;//jQuery('.swiper-slide');

        if (pos>top + elemH||pos<top||top > pos + windowHeight) {
          param.each(function(){
            param.css('transform', 'translateY(0px)');

          })
          return;
        }

        param.each(function(){
          param.css('transform', 'translateY(' + Math.round((pos-top) * 0.35) + 'px)');

        })
      });
    }
  }

  ,menuOnMobile_handle : function(){

    if($('.mobile-version .mega-menu .position-left').length > 0 || $('.mobile-version .mega-menu .position-center').length > 0 || $('.mobile-version .mega-menu .position-right').length > 0){
      $('.mobile-version .mega-menu .position-left,.mobile-version .mega-menu .position-center,.mobile-version .mega-menu .position-right').attr('style','');
      $('.mobile-version .mega-menu .mega-col').each(function(){
        $(this).parents('.row').first().before($(this).children());
      })
      $('.mobile-version .mega-menu .row').remove();
    }

    if($('.mobile-version .mega-menu .menu-proudct-carousel').length > 0){
      setTimeout(function(){
        $('.mobile-version .mega-menu .menu-proudct-carousel').prepend('<div class="back-prev-menu"><span class="expand"></span></div>');
      },500);
    }
    jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(event){
      let title = $(this).parent().find('a').first().text().trim().split('\n')[0];
      let e = $(this).parents('.dropdown').first();

      if(e.parent().hasClass('col-item')){
        e.parent().addClass('active');
        e.parents('.dropdown-menu').first().addClass('sub-open');
      }
      else{
        e.addClass('active');
        e.parent().addClass('sub-open');
      }
      if (e.hasClass('dropdown') ) {
        let child = e.children('.dropdown-menu');
        if(child.length > 0){
          if (child.hasClass('menu-mobile-open') == false) {
            if(child.find('.banners').length > 0){
              child.find('.banners').each(function(){
                let el = $(this);
                if (el.hasClass('no-title-2')) {
                  let img = el.children('.dropdown-menu').find('img');

                  let temp = el.children('.dropdown-menu').find('img').parents('li').first().html();
                  el.append(el.html(temp).removeClass('dropdown'));

                  if (img.length > 0 && !img.hasClass('lazyloaded')) {
                    el.addClass('hide')
                  }else{
                    el.removeClass('hide')
                  }

                }
              })
            }
            child.addClass('menu-mobile-open');
            if (title.length > 0) {
              child.children('.back-prev-menu').find('.expand').html(title);
            }
            return false;
          }
        }
      }

      if ($(this).parent().hasClass('back-prev-menu')) {
        let e = $(this).parent();
        e.parents('.dropdown-menu').first().removeClass('menu-mobile-open');

        if(e.parents('.dropdown').first().parent().hasClass('col-item')){
          e.parents('.dropdown').first().parent().removeClass('active');
          e.parents('.sub-open').first().removeClass('sub-open');
        }
        else{
          e.parents('.dropdown').first().removeClass('active');
          e.parents('.dropdown').first().parent().removeClass('sub-open');
        }
      }

    });
  }

  ,vertical_menu_handle : function(){// Handle menu vertical mobile
    jQuery(document).on('click','.vertical-menu .vertical-navbar .dropdown .expand',function(e){
      if ($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).parent().removeClass('active');
      }else{
        $(this).parent().children().each(function(){
            $(this).removeClass('active');
        })
        $(this).addClass('active');
        $(this).parent().addClass('active');
      }
    })
  }
  
  ,megamenuWithTabs : function(){
    jQuery(".tab-title .title-item").hover(function(e){
      $('.title-item').removeClass('active');
      $('.tab-content-inner').removeClass('active');

      var _class = $(this).attr('data-id');
      var idclass = "." + _class;
      var e = jQuery(this);

      e.addClass('active');
      $(idclass).addClass('active');
    });

    jQuery(".mega-menu").mouseleave(function(){
      $('.title-item').removeClass('active');$('.title-item-1').addClass('active');
      $('.tab-content-inner').removeClass('active');$('.mm-tabs-1').addClass('active')
    });
  }
  ,productDescription : function(){
    $('.nav-ver-2 li a').on('click',function(e){
      e.preventDefault();

      if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active').find('.tab-pane').removeClass('show active');
      }else{
        $('.nav-ver-2 li').removeClass('active').find('.tab-pane').removeClass('show active');
        $(this).parent().addClass('active').find('.tab-pane').addClass('show active');
      }
    })
  }
  ,deadLine_time : function(){
    var _deadline_time = parseInt($('.shipping-time').attr('data-deadline'));
    var _currentDate = new Date();

    var _dueDate = new Date( _currentDate.getFullYear(), _currentDate.getMonth(), _currentDate.getDate());
    _dueDate.setHours(_deadline_time);

    switch(_currentDate.getDay()) {
      case 0: // Sunday
      _dueDate.setDate(_dueDate.getDate() + 1);
      break;

      case 5: // Friday
      if(_currentDate >= _dueDate){
        _dueDate.setDate(_dueDate.getDate() + 3);
      }
      break;

      case 6: // Saturday
      _dueDate.setDate(_dueDate.getDate() + 2);
      break;

      default:
      if(_currentDate >= _dueDate){
        _dueDate.setDate(_dueDate.getDate() + 1);
      }
    }
    $('.countdown_deadline').countdown({until: _dueDate, format: 'HMS', padZeroes: true, labels:["Years","Months","Weeks","Days","Hours","Minutes","Seconds"], labels1:["Year","Month","Week","Day","Hour","Minute","Second"]});
  }
  ,delivery_time : function(){
    var today = new Date();
    var business_days = parseInt($('.shipping-time').attr('data-deliverytime'));
        var deliveryDate = today; //will be incremented by the for loop
        var total_days = business_days; //will be used by the for loop

        for(var days=1; days <= total_days; days++) {
          deliveryDate = new Date(today.getTime() + (days *24*60*60*1000));
          if(deliveryDate.getDay() == 0 || deliveryDate.getDay() == 6) {
            //it's a weekend day so we increase the total_days of 1
            total_days++
          }
        }

        var weekday = new Array(7);
        weekday[0] =  "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        var _day = weekday[deliveryDate.getDay()];

        var month = new Array();
        month[0] = "January";
        month[1] = "February";
        month[2] = "March ";
        month[3] = "April";
        month[4] = "May";
        month[5] = "June";
        month[6] = "July";
        month[7] = "August";
        month[8] = "September";
        month[9] = "October";
        month[10] = "November";
        month[11] = "December";
        var _month = month[deliveryDate.getMonth()];

        $('.delivery-time').html('Want it delivered by' + '&nbsp;' + '<strong>' + _day + ',' + '&nbsp;' + deliveryDate.getDate() + '&nbsp;' + _month + '?' + '</strong>');
      }

  ,resizeCollection : function(){
    if ($('body').hasClass('templateCollection')) {
      let sb = $('.sidebar-column')
      ,filter_height = $('.mobile-layout-bar')[0].clientHeight;
      if (AT_Main.getWidthBrowser() < 992 ){
        $('#footer-content').css('margin-bottom', filter_height);
        $('.filter-component').attr('style','').removeClass('accordion toggle full').addClass('drawer');
        if (sb.length > 0) {
          $('.sb-widget .sbw-filter').each(function(){
            $('.filter-component.drawer').append($(this));
          })
        }

      }else{
        $('#footer-content').css('margin-bottom', 0);
        $('.filter-component').removeClass('drawer').addClass($('.cata-toolbar').data('filter'));
        if (sb.length > 0) {
          $('.sb-widget').each(function(index,val){
            if ($(this).data('prefix')) {
              $(this).append($('.filter-component').find('.sb-filter.'+$(this).data('prefix')).parents('.sbw-filter'));
            }
          })
          jQuery("#page-body").trigger('click');
        }
      }
    }
  }
  ,quickShop_drawerHandle : function(){
    $('#page-body').on('click',function(){
      AT_Main.fixReturnScroll();
      if ($('body').hasClass('qs-opened')) {
        $('body').removeClass('qs-opened');
        $('.qs-drawer').removeClass('show');

      }
      jQuery('.layer-addcart-modal').length && jQuery('.layer-addcart-modal').removeClass('show');
    })
  }
  ,init_zoom_img : function(){
    $('.image-zoom').parent().trigger('zoom.destroy');
    if (AT_Main.getWidthBrowser() > 767 ) {
      $('.image-zoom').each(function(index, el) {
        let largeImg = $(this).parents('.image-zoom-parent').data('zoom-size');
        if(typeof largeImg != 'undefined'){
          $(this).parents('.image-zoom-parent').zoom({
            url: largeImg,
            on:'mouseover',
            touch:false
          });
        }

      });
    }
  }
  ,updateLayerCart : function(obj){
    let img = '<img class="lazyload" data-src="'+obj.image+'" alt>';

    if ( obj.image == '' ){$('.cart-img').css('display', 'none');}
    else{$('.cart-img').empty().html(img);}

    $('.layer-addcart-modal .prod-title').empty().html(obj.title);
    $('.layer-addcart-modal .prod-price').empty().html(Shopify.formatMoney(obj.price, _bc_config.money_format));
    Shopify.getCart(function(cart) {
      $('#layer-cart-total').empty().html(Shopify.formatMoney(cart.total_price, _bc_config.money_format));
      if( _bc_config.enable_multiple_currencies == "true" ){
        currenciesCallbackSpecial('#layer-cart-total span.money');
      }
    });

    setTimeout(function(){
      $('.new-loading').removeClass('loading');
      let e, e_s, top;
      if (AT_Main.getWidthBrowser() >= 768) {
        e = $('#header-style .header-desktop');
        e_s = $('#header-style .header-desktop .header-navigation');
        e.data('sticky') ? top = e_s.outerHeight() : top = 0;
      }else{
        e = $('#header-style .header-mobile');
        e_s = $('#header-style .header-mobile .header-mobile--bottom-content');
        e.data('sticky') ? top = e_s.outerHeight() : top = 0;
      }

      $('.layer-addcart-modal').css('top', top+'px').addClass('show');
    },500)

  }
  ,fixedHeader : function(){
    //Keep track of last scroll
     var header = jQuery("#header-style");
     var body_content = jQuery("#body-content");
     var lastScroll = 0;
     let timer_fix = null;

    $(window).on('scroll' , function() {
      if($('.header-desktop').data('sticky')){
        if(AT_Main.checkLayout() > 2) {
          //Sets the current scroll position
          var st = jQuery(window).scrollTop();
          var scroll = header.offset().top + header[0].clientHeight + 100;
          //Determines up-or-down scrolling
          if (st > scroll) {
            if (st > lastScroll) {
              //Replace this with your function call for downward-scrolling
              header.removeClass("header-fixed");
              body_content.removeClass("has-header-fixed");
            } else { 
              header.addClass("header-fixed");
              body_content.addClass("has-header-fixed");
            }
          } else {
            //Replace this with your function call for upward-scrolling
            if (st < scroll) {
              header.removeClass("header-fixed");
              body_content.removeClass("has-header-fixed");

              /*header.find('.header-desktop .vertical-menu .head').addClass('opened');
              header.find('.header-desktop .vertical-menu .head').next().addClass('opened');
              header.find('.header-desktop .vertical-menu .head i').removeClass('icon-add');
              header.find('.header-desktop .vertical-menu .head i').addClass('icon-minus');*/
            }
          }
          //Updates scroll position
          lastScroll = st;
        } 
      }

      if($('.header-mobile').data('sticky')){
        if(AT_Main.checkLayout() <= 2) {
          var st = jQuery(window).scrollTop();
          var scroll = header.offset().top + header[0].clientHeight;
          //$(window).scrollTop() < scroll ? header.removeClass('h-mobi-sticky') : header.addClass('h-mobi-sticky');

            if (st > scroll) {
              if (st > lastScroll) {
                //Replace this with your function call for downward-scrolling
                
                if (timer_fix === null) {
                  timer_fix = setTimeout(function(){
                    header.removeClass('h-mobi-sticky');
                  }, 100);
                }
              } else { 
                clearTimeout(timer_fix);
                timer_fix = null;
                header.addClass('h-mobi-sticky');
              }
            } else {
              //Replace this with your function call for upward-scrolling
              if (st < scroll) {
                header.removeClass('h-mobi-sticky');
              }
            }
            //Updates scroll position
            lastScroll = st;
        } 
      }
    })

  }

  ,header_handle : function(){
    if (AT_Main.getWidthBrowser() >= 992){ 
      var elem_height = $('.header-desktop');
      $('#header-style').css('min-height',elem_height[0].clientHeight);
    } else {
      var clone = $("#header-style").clone().removeClass('h-mobi-sticky').css("display","block").css("position","absolute").css("left","-9999px");
      $("#header-style").after(clone);
      var elem_height = $('.header-mobile');
      var header_height = elem_height[1].clientHeight;
      clone.remove();
      $('#header-style').css('min-height',header_height);
    }
  }

  ,init_CountDown : function(){
    let e,f,g;
    if ($('.detail-deal').length) {
      e = $('.detail-deal');
    }
    if ($('.deal-count').length) {
      f = $('.deal-count');
    }
    if ($('.block-countdown .wrapper-countdown').length) {
      g = $('.block-countdown .wrapper-countdown');
    }
    if (typeof e != 'undefined') {
      let currentDate = new Date();
      e.each(function(){
        let $this = $(this), child = $this.children();
        let prod_id = child.data('id');
        let prod_dueDate = child.data('date');
        let dueDate = prod_dueDate.split('/');
        let n_date = dueDate[2] +'-'+dueDate[0]+'-'+dueDate[1];
        let newdueDate = new Date(n_date);

        if(currentDate < newdueDate){
          $('.countdown_'+prod_id).countdown({until: newdueDate,format: 'DHMS',labels: ['Yrs', 'Mon', 'Wek', 'Day', 'Hrs', 'Min', 'Sec'], });
          $this.removeClass('hide');
        }
      });
    }
    if (typeof f != 'undefined') {
      let currentDate = new Date();
      f.each(function(){
        let $this = $(this), child = $this.children();
        let prod_id = child.data('id');
        let prod_dueDate = child.data('date');
        let dueDate = prod_dueDate.split('/');
        let n_date = dueDate[2] +'-'+dueDate[1]+'-'+dueDate[0];
        let newdueDate = new Date(n_date);

        if(currentDate < newdueDate){
          $('.countdown_'+prod_id).countdown({until: newdueDate,format: 'DHMS',labels: ['Yrs', 'Mon', 'Wek', 'Day', 'Hrs', 'Min', 'Sec'], });
          $this.removeClass('hide');
        }
      });
    }
    if (typeof g != 'undefined') {
      let currentDate = new Date();
      g.each(function(){
        let $this = $(this);
        let prod_id = $this.data('id');
        let prod_dueDate = $this.data('date');
        let dueDate = prod_dueDate.split('/');
        let n_date = dueDate[2] +'-'+dueDate[0]+'-'+dueDate[1];
        let newdueDate = new Date(n_date);

        if(currentDate < newdueDate){
          $this.countdown({until: newdueDate,format: 'DHMS',labels: ['Yrs', 'Mon', 'Week', 'Day', 'Hrs', 'Min', 'Sec'], });
          $this.parent().removeClass('hide');
        }
      });
    }
  }
  ,init_carousel : function(el){
    el.length && el.each(function(index, value) {
      var e = $(this);
      var _rtl      = _bc_config.enable_rtl == 'true' ? true    : false;
      e.owlCarousel({
        rtl      : _rtl
        ,nav     : e.data('nav')
        ,dots     : e.data('dot')
        ,autoplay: e.data('autoplay')
        ,loop: e.data('loop')
        ,autoplayTimeout : 3000
        ,autoplayHoverPause: true
        ,responsive : {
          0:{
            items: e.data('mob')
            ,margin: e.data('padding-mob')
          }
          ,768:{
            items: e.data('desk') - 1
            ,margin: e.data('padding')
          }
          ,992:{
            items: e.data('desk')
            ,margin: e.data('padding')
          }
        }
        ,navText  : ['<span class="button-prev"></span>', '<span class="button-next"></span>']
      });
    })
  }
  ,init_carousel2 : function(el){
    el.length && el.each(function(index, value) {
      var e = $(this);
      if (!e.hasClass('owl-loaded')) {
        var _rtl      = _bc_config.enable_rtl == 'true' ? true    : false
        ,_owl_xs      = e.data('owl-xs') ? e.data('owl-xs') : 1
        ,_owl_xxs     = e.data('owl-xxs')? e.data('owl-xxs') : _owl_xs
        ,_owl_md      = e.data('owl-md') ? e.data('owl-md') : _owl_xs
        ,_owl_sm      = e.data('owl-sm') ? e.data('owl-sm') : _owl_xs
        ,_owl_lg      = e.data('owl-lg') ? e.data('owl-lg') : _owl_md
        ,_owl_xl      = e.data('owl-xl') ? e.data('owl-xl') : _owl_lg
        ,_loop        = e.data('loop')        ? e.data('loop')        : false
        ,_nav         = e.data('nav')         ? e.data('nav')         : false
        ,_dot         = e.data('dot')         ? e.data('dot')         : false
        ,_autoplay    = e.data('autoplay')    ? e.data('autoplay')    : false
        ,_thumbs      = e.data('thumbs')      ? e.data('thumbs')      : false
        ,_padding_md  = e.data('padding-md')  ? e.data('padding-md')  : 0
        ,_padding_xs  = e.data('padding-xs')  ? e.data('padding-xs')  : 0
        ,_center      = e.data('center')      ? e.data('center')      : false
        ,_duration    = e.data('duration')    ? e.data('duration')    : 3000
        ,_effectIn    = e.data('effect-in')   ? e.data('effect-in')   : false
        ,_effectOut   = e.data('effect-out')  ? e.data('effect-out')  : false
        ,_smoothAutoplay = e.data('smooth-autoplay') || 'false';

        /* Custom width xl over 5,6 items or Big product */
        if (e.data('bigitem')){
          _owl_xl_min = _owl_xl - 1;
        } else if (_owl_xl == 5 && _center != true){
          _owl_xl_min = _owl_xl - 1;
        } else if (_owl_xl > 5 ){
          _owl_xl_min = _owl_xl - 2;
        } else {
          _owl_xl_min = _owl_xl;
        }

        if(JSON.parse(_smoothAutoplay)){
          _autoplay = false;
          _loop = true;
        }

        // loop                : _loop,
        !e.hasClass('owl-carousel') && e.addClass('owl-carousel');
        !e.hasClass('owl-loaded') && e.owlCarousel({
          rtl                : _rtl
          ,autoplay           : _autoplay
          ,autoplayTimeout    : _duration
          ,center             : _center
          ,nav                : _nav
          ,dots               : _dot
          ,thumbs             : _thumbs
          ,thumbsPrerendered  : _thumbs
          ,animateIn          : _effectIn
          ,animateOut         : _effectOut
          ,responsive : {
            0:{
              items   : _owl_xs
              ,margin : _padding_xs
              ,loop: Number.isInteger(_owl_xs) ? _loop : true
            }
            ,375:{
              items   : _owl_xxs
              ,margin : _padding_xs
              ,loop: Number.isInteger(_owl_xxs) ? _loop : true
            }
            ,576:{
              items   : _owl_sm
              ,margin : _padding_xs
              ,loop: Number.isInteger(_owl_sm) ? _loop : true
            }
            ,768:{
              items   : _owl_md
              ,margin : _padding_md
              ,loop: Number.isInteger(_owl_md) ? _loop : true
            }
            ,992:{
              items   : _owl_lg
              ,margin : _padding_md
              ,loop: Number.isInteger(_owl_lg) ? _loop : true
            }
            ,1200:{
              items   : _owl_xl_min
              ,margin : _padding_md
              ,loop: Number.isInteger(_owl_xl) ? _loop : true
            }
            ,1440:{
              items   : _owl_xl
              ,margin : _padding_md
              ,loop: Number.isInteger(_owl_xl) ? _loop : true
            }
          }
          ,navText  : ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

        if(JSON.parse(_smoothAutoplay)){
          AT_Main.smartAutoplay_carousel(e);
        }
      }
    })
  }

  ,smartAutoplay_carousel : function(element){      
    var slideTimer = null;
    var transXVal = 0;
    var transXDelta = 0.5;
    var $win = $(window);

    function playSlideCarousel(){        
      transXVal = transXVal - transXDelta;

      var stage = element.find('.owl-stage');
      var limit = - stage.width() + $(window).width();

      if (transXVal < limit) {transXVal = 0;}

      stage.css('transform', 'translateX('+ transXVal + 'px)');
    }; 



    if (slideTimer == null) {
      slideTimer = setInterval(playSlideCarousel, 2);
    }

    var isDraggingSlider = false;
    var prevXPos = 0, clickedXPos = 0;

    element.css('cursor','pointer');
    element
    .on('mouseleave', function() {
      isDraggingSlider = false;
      slideTimer = setInterval(playSlideCarousel, 2);
    })
    .on('mouseenter', function() {
      clearInterval(slideTimer);
    })
    .on('mousedown', function(e) {
      isDraggingSlider = true;
      prevXPos = e.pageX;
      clickedXPos = e.pageX;

      return false;
    })
    .on('touchstart', function(e) {
      clearInterval(slideTimer);
      isDraggingSlider = true;
      prevXPos = e.originalEvent.touches[0].pageX;
      clickedXPos = e.originalEvent.touches[0].pageX;

    })
    .on('mousemove', function(e) {
      if (isDraggingSlider) {

        transXVal = transXVal + (e.pageX - prevXPos);
        prevXPos = e.pageX;

        var stage = element.find('.owl-stage');
        var limit = - stage.width() + $win.width();

        if (transXVal < limit) {transXVal = 0;}
        if (transXVal > 0) {transXVal = 0;}

        stage.css('transform', 'translateX('+ transXVal + 'px)');

      }
    })
    .on('touchmove', function(e) {
      if (isDraggingSlider) {


        transXVal = transXVal + (e.originalEvent.touches[0].pageX - prevXPos);
        prevXPos = e.originalEvent.touches[0].pageX;


        var stage = element.find('.owl-stage');
        var limit = - stage.width() + $win.width();

        if (transXVal < limit) {transXVal = 0;}

        stage.css('transform', 'translateX('+ transXVal + 'px)');

      }
    })
    .on('mouseup', function() {
      isDraggingSlider = false;
    })
    .on('touchend', function(e) {
      isDraggingSlider = false;
      slideTimer = setInterval(playSlideCarousel, 2);
      if (prevXPos == clickedXPos) {
        console.log("should work as normal touch");
      }
      else {
       return false;
     }
   })
    .on('click', function(e) {
      isDraggingSlider = false;
      if (clickedXPos != e.pageX) {
        return false;
      }

    });

    var $prevbutton = element.find('.owl-prev');
    var $nextbutton = element.find('.owl-next');
    var imagewidth = element.find('.owl-item')[0].getBoundingClientRect().width;

    $prevbutton.off('click');
    $prevbutton.on('click', function(e) {
      clearInterval(slideTimer);
      
      var floatval = transXVal / imagewidth;
      var intval = Math.floor(floatval);
      transXVal = (intval + 1) * imagewidth;
      
        var stage = element.find('.owl-stage');
        var limit = - stage.width() + $win.width();

        if (transXVal < limit) {transXVal = 0;}
        if (transXVal > 0) {transXVal = limit;}

        stage.css('transform', 'translateX('+ transXVal + 'px)');
    })
    .on('mouseup', function() {
      clearInterval(slideTimer);
    })
    .on('touchend', function() {
      
      var floatval = transXVal / imagewidth;
      var intval = Math.floor(floatval);
      transXVal = (intval + 1) * imagewidth;
      
        var stage = element.find('.owl-stage');
        var limit = - stage.width() + $win.width();

        if (transXVal < limit) {transXVal = 0;}
        if (transXVal > 0) {transXVal = limit;}

        stage.css('transform', 'translateX('+ transXVal + 'px)');
      
      slideTimer = setInterval(playSlideCarousel, 2);
      return false;
    });
    $nextbutton.off('click');
    $nextbutton.on('click', function(e) {
      
      clearInterval(slideTimer);
      
      var floatval = transXVal / imagewidth;
      var intval = Math.ceil(floatval);
      transXVal = (intval - 1) * imagewidth;
      
        var stage = element.find('.owl-stage');
        var limit = - stage.width() + $win.width();

        if (transXVal < limit) {transXVal = 0;}
        if (transXVal > 0) {transXVal = limit;}

        stage.css('transform', 'translateX('+ transXVal + 'px)');
    })
    .on('mouseup', function() {
      clearInterval(slideTimer);
    })
    .on('touchend', function() {
      
      var floatval = transXVal / imagewidth;
      var intval = Math.ceil(floatval);
      transXVal = (intval - 1) * imagewidth;
      
        var stage = element.find('.owl-stage');
        var limit = - stage.width() + $win.width();

        if (transXVal < limit) {transXVal = 0;}
        if (transXVal > 0) {transXVal = limit;}

        stage.css('transform', 'translateX('+ transXVal + 'px)');
      
      slideTimer = setInterval(playSlideCarousel, 2);
      return false;
    });

  } 
  ,init_masonry : function(){
    jQuery('.home-banner-items').length && jQuery('.home-banner-items').each(function(){
      if (jQuery(this).find('.home-banner-carousel').length) {
        AT_Main.init_carousel2(jQuery('.home-banner-carousel'));
      }

      if (jQuery(this).find('.home-banner-masonry').length) {
        let i_masonry = function(e,grid){
          e = new Muuri(grid, {
            items: '.banner-item'
            ,visibleStyles: {}
            ,layout: {
              fillGaps: true,
              rounding: false
            }
          })
        }

        let _class = '.' + jQuery(this).find('.home-banner-masonry').attr('class').replace(' ','.') + ' .bc-masonry';
        jQuery(this).find('.bc-masonry').each(function(){
          let $module = $(this);
          this.addEventListener('load', i_masonry($module,_class), true);
          i_masonry($module,'.bc-masonry');

          jQuery(this).find('.bc-masonry').length && $(window).resize(function(event) {i_masonry($module,'.bc-masonry')});
        });
      }
    })
  }
  ,footer_handle : function(){
    $(document).on('click','.viewmore-mobile',function(e){
      e.preventDefault();
      $('.footer-container .vie-mob').each(function(index, el) {
        $(this).toggle('slow');
        $('html, body').stop().animate({
          scrollTop: jQuery(document).outerHeight()
        }, 700, 'swing');
      });
    });

    jQuery(window).resize(function() {
      if (AT_Main.getWidthBrowser() >= 768) {
        $('.vie-mob').each(function(index, el) {
          $(this).removeAttr('style');
        })
      }
    })
  }

  ,triggerVideo_event : function(selector){
    let _this = selector;
    if(_this.find('video').length) {
      let _video = _this.find('video');
      _video.toggleClass('is-playing');
      _video.hasClass('is-playing') ? _video[0].play() : _video[0].pause();
    }
  }

  ,slickProductPage: function(){
    let _rtl = _bc_config.enable_rtl == 'true' ? true : false;
    jQuery('.slider-for-03').length && !jQuery('.slider-for-03').hasClass('slick-initialized') && jQuery('.slider-for-03').slick({
      slidesToShow: 1
      ,slidesToScroll: 1
      ,rtl:_rtl
      ,swipe: false
      ,arrows: false
      ,fade: _rtl ? false : true
      ,useTransform: false
      ,asNavFor: '.slider-thumbs-03'
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      let _currentSlide = $('.slider-for-03 .slick-slide[data-slick-index="'+currentSlide+'"]')
         ,_nextSlide = $('.slider-for-03 .slick-slide[data-slick-index="'+nextSlide+'"]');
      AT_Main.triggerVideo_event(_currentSlide);
      AT_Main.triggerVideo_event(_nextSlide);
    });

    jQuery('.slider-thumbs-03').length && !jQuery('.slider-thumbs-03').hasClass('slick-initialized') &&jQuery('.slider-thumbs-03').slick({
       infinite: false
      ,slidesToShow: 5
      ,slidesToScroll: 1
      ,rtl:_rtl
      ,focusOnSelect: true
      ,arrows: true
      ,asNavFor: '.slider-for-03'
      ,prevArrow: $('.slick-thumb-btn-03 .btn-prev')
      ,nextArrow: $('.slick-thumb-btn-03 .btn-next')

    });

    jQuery('.slider-for-06').length && jQuery('.slider-for-06').slick({
      infinite: false
      ,slidesToShow: 1
      ,slidesToScroll: 1
      ,vertical: true
      ,verticalSwiping: true
      ,arrows: false
      ,asNavFor: '.slider-thumbs-06'
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      let _currentSlide = $('.slider-for-06 .slick-slide[data-slick-index="'+currentSlide+'"]')
         ,_nextSlide = $('.slider-for-06 .slick-slide[data-slick-index="'+nextSlide+'"]');
      AT_Main.triggerVideo_event(_currentSlide);
      AT_Main.triggerVideo_event(_nextSlide);
    });
    jQuery('.slider-thumbs-06').length && jQuery('.slider-thumbs-06').fadeIn() && jQuery('.slider-thumbs-06').slick({
      infinite : false
      ,slidesToShow : 5
      ,slidesToScroll : 1
      ,asNavFor : '.slider-for-06'
      ,vertical : true
      ,verticalSwiping : true
      ,dots : false
      ,arrows : false
      ,focusOnSelect : true

    });
    jQuery('.slider-thumbs-03, .slider-thumbs-06').removeClass('opacity-0');
  }
  ,productPage_variantFilter : function(groupImage){
    /*jQuery('#slide--thumbs').hasClass('slider-thumbs-06') && jQuery('#slide--thumbs .slick-list').addClass('full-height');
    jQuery('#slide--main').attr('data-filter',groupImage);
    if (jQuery('.slider-filter').hasClass('slick-initialized')) {
      jQuery('.slider-filter .slick-slide').each(function() {
        let _group_class = jQuery(this).find('.slick-item').attr('data-match');
        jQuery(this).addClass(_group_class);
      });
      jQuery('.slider-filter').slick('slickUnfilter');
      jQuery('.slider-filter').slick('slickFilter','.'+groupImage+',.group-all');
      jQuery('.slider-filter').attr('data-filter','.'+groupImage);
    }*/
  }

  ,productPage_handle : function(){

    if ($('.page-product').length && !$('#product-image').hasClass('thumbnail-position-bottom')&& !$('.page-product').hasClass('product-slider')) {
      let main = $('#slide--main')
        ,thumb = $('#slide--thumbs');

      jQuery('.slider-filter').hasClass('slick-initialized') && jQuery('.slider-filter').slick('slickUnfilter');

      if (AT_Main.getWidthBrowser() > 767) {
        if (!main.hasClass('slick-gallery-image') && main.hasClass('slider-for-03')) {
          $('.slider-for-03,.slider-thumbs-03').slick('unslick');

          main.toggleClass('slider-for-03 slider-for-06');
          thumb.toggleClass('slider-thumbs-03 slider-thumbs-06 opacity-0');
          $('.slick-btn-03').addClass('hide');
          $('.slick-btn-06').removeClass('hide');
          AT_Main.slickProductPage();
        }

        if(main.hasClass('slick-gallery-image') && main.hasClass('slider-for-03')){
          $('.slider-for-03').slick('unslick');
          $('.slider-thumbs-03').length && $('.slider-thumbs-03').slick('unslick');
          main.removeClass('slider-for-03');
          main.children('.item').removeClass('slick-item');
          thumb.removeClass('slider-thumbs-03').addClass('hide');
          $('.slick-btn-03').addClass('hide');
        }
        $('#slide--main').data('zoom') && AT_Main.init_zoom_img();
      }
      else {
        if (main.hasClass('slider-for-06')) {
          $('.slider-for-06,.slider-thumbs-06').slick('unslick');
          main.toggleClass('slider-for-03 slider-for-06');
          thumb.toggleClass('slider-thumbs-03 slider-thumbs-06 opacity-0');
          $('.slick-btn-03').removeClass('hide');
          $('.slick-btn-06').addClass('hide');
          AT_Main.slickProductPage();
        }
        if(main.hasClass('slick-gallery-image') && !main.hasClass('slider-for-03')){
          main.addClass('slider-for-03');
          main.children('.item').addClass('slick-item');
          thumb.removeClass('hide').addClass('slider-thumbs-03');
          $('.slick-btn-03').removeClass('hide');
          AT_Main.slickProductPage();
        }
      }
      jQuery(".fancybox").length && jQuery(".fancybox").jqPhotoSwipe();
      let a = jQuery('#slide--main').attr('data-filter');
      if (a) {
        AT_Main.productPage_variantFilter(a);
        thumb.find('.slick-slide').first().trigger('click');
      }
    }
  }
  ,resize_handle : function(){
    AT_Main.fixReturnScroll();/*Reset Page when fixNoScroll had called before*/
    AT_Main.resizeCollection();
    AT_Main.header_handle();
    //AT_Main.fixedHeader();
    AT_Main.cartMobile();
    AT_Main.productPage_handle();

    if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened')){
      jQuery("#page-body").trigger('click');
    }

    if(!$('.header-desktop').data('sticky')){
      jQuery(".header-container").removeClass("header-fixed fadeInDown animated");
      jQuery("#body-content").removeClass("has-header-fixed");
    }
    if(!$('.header-mobile').data('sticky')) {
      jQuery(".header-container").removeClass("header-fixed fadeInDown animated");
      jQuery("#body-content").removeClass("has-header-fixed");
    }
  }
  ,init_instafeed : function(){
    jQuery('.home-instagram').length && jQuery('.home-instagram').each(function(index, el) {

      var id = jQuery(el).attr('data-section-id');
      var insta_target = '#home_instagram_list_'+id;
      if( jQuery(insta_target).length){
        if( 'undefined' === typeof Instafeed ){
          console.log(" Instafeed has not defined yet! ");
          return;
        }

        var instagram_list, $insta = jQuery(insta_target), filter = jQuery(insta_target).attr('data-filter'),image_tag = '';
        jQuery(insta_target).empty();
        jQuery(insta_target).attr('data-lazyload') ? image_tag = '<img class="filter-'+filter+' lazyload" data-src="{{image}}"/>' : image_tag ='<img class="filter-'+filter+'" src="{{image}}"/>';

        instagram_list = new Instafeed({
          get: "user"
          ,target     : 'home_instagram_list_'+id
          ,accessToken: $insta.data('token-key')
          ,userId     : $insta.data('uid')
          ,limit      : $insta.data('limit')
          ,resolution : "standard_resolution"
          ,template   : '<a href="{{link}}" target="_blank" rel="noopener">'+image_tag+'<div class="instagram-hover">\
          <div class="insta-comment"><p class="icon-heart">{{likes}}</p><p class="icon-comment-empty">{{comments}}</p></div></div></a>'
          ,after: function() {jQuery('#home_instagram_list_'+id+'.insta-carousel').length && AT_Main.init_carousel(jQuery('#home_instagram_list_'+id+'.insta-carousel'));}
        });
        instagram_list.run();
      }
    });

  }

  ,resetFilter: function(chosen_select_1, chosen_select_2, chosen_select_3, search_button){
      let jQuery_chosen_select_1 = "#" + chosen_select_1;
      let jQuery_chosen_select_2 = "#" + chosen_select_2;
      let jQuery_chosen_select_3 = "#" + chosen_select_3;
    
      $('.reset-filter').on('click', function(){
        $('#collection-search-wrapper .selector-wrapper').addClass('pending');
        setTimeout(function(){
          $(jQuery_chosen_select_1).val("All")
          $(jQuery_chosen_select_1).trigger("chosen:updated");

          $(jQuery_chosen_select_2).html('<option value="All">All</option>');
          document.getElementById(chosen_select_2).disabled = true;
          $(jQuery_chosen_select_2).trigger("chosen:updated");

          $(jQuery_chosen_select_3).html('<option value="All">All</option>');
          document.getElementById(chosen_select_3).disabled = true;
          $(jQuery_chosen_select_3).trigger("chosen:updated");

          $('#' + search_button).attr('href', '/collections/all')
          $('.reset-filter').hide()

          $('#collection-search-wrapper .selector-wrapper').removeClass('pending')
        },1000)
    })
  }

  
  ,init_onload : function(){
    setTimeout(function(){
      if ($('.templateProduct .single-option-selector').length) {
        $('.templateProduct .single-option-selector').each(function(){
          if($(this).find('.icon-angle-down').length == 0 )
            $(this).after('<i class="icon-angle-down"></i>');
        })
      }
      $('.snptwdgt-rtd__ftr').length && $('.snptwdgt-rtd__ftr').remove();
    },400);
  }

  ,toggleVerticalMenu: function() {
    $('.header-navigation .vertical-menu .head').on('click', function(){
      if ($(this).find('i').hasClass('icon-minus')){
        $(this).removeClass('opened');
        $(this).next().removeClass('opened');
        $(this).find('i').removeClass('icon-minus')
        $(this).find('i').addClass('icon-add')
      }
      else {
        $(this).addClass('opened');
        $(this).next().addClass('opened');
        $(this).find('i').addClass('icon-minus')
        $(this).find('i').removeClass('icon-add')
      }
    })
  }

  ,init_handle : function(){
    $('.new-loading').after($('.mobile-version'))

    $('.rating-links a').click(function() {
      if($('.rating-links').hasClass('review-position-inside')){
        $('.product-simple-tab ul li a').removeClass('active');
        $('#tab_review_tabbed a').addClass('active');
        $('.product-simple-tab .tab-content .tab-pane').removeClass('show active');
        $('#tab-review').addClass('show active');
        $('#tab_review_tabbed').scrollToMe();
      }
      else if($('.rating-links').hasClass('review-position-below')){
        $('#tab_review_tabbed').scrollToMe();
      }
      return false;
    });

    if ($('.description-product').length) {
      $('.description-product ul').find('li').first().children('a').trigger('click');
    }

    jQuery(document).on('click','.share-button' , function(e) {
      e.preventDefault();
      if($('.share-icons').is(":hidden")){
        $('.share-icons').slideDown();
      } else {
        $('.share-icons').slideUp();
      }
    });
    $('.grid-uniform').length && $('.grid-uniform').each(function(){
      if($(this).find('.advanced-filters').children().length == 0){$(this).parents('.sb-widget').removeClass('d-lg-block');}
    });

    jQuery(document).on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if (jQuery(this).data('term')) {
        if (jQuery('#agree').is(':checked')) {jQuery(this).submit();}
        else {
          alert("You must AGREE with Terms and Conditions.");
          return false;
        }
      }
    }).on('click','#agree-mobile', function(){
      jQuery('#agree-mobile').is(':checked') ? jQuery('#agree').prop('checked', true) : jQuery('#agree').prop('checked', false);
    });
  }

  ,toggleFtMenuMobile: function(){
    $('.footer-menu h6').find('span.trigger-mobile-menu').each(function(){
      $(this).on('click', function(){
        if($(this).find('i').hasClass('icon-angle-down')){
          $(this).find('i').removeClass('icon-angle-down');
          $(this).find('i').addClass('icon-angle-up');
          $(this).parent().next().slideDown();
        } else {
          $(this).find('i').addClass('icon-angle-down');
          $(this).find('i').removeClass('icon-angle-up');
          $(this).parent().next().slideUp();
        }
      })
    })
  }

  ,pointOpen: function(obj){
    obj.off('click.pointClick').on('click.pointClick', function(){
      if(jQuery(this).hasClass('point-open')){
        jQuery(this).removeClass('point-open')
      }
      else {
        jQuery(this).addClass('point-open')
      }
    })            
  }

  ,groupFilterIntoParentDiv: function(){
    if($('body').hasClass('templateCollection')){
      let el = $("<div class='filter-wrapper d-none d-lg-block'></div>");

      if($('#sidebar').find('.filter-item').length > 0) {
        let parentEl = document.getElementById('sidebar');
        let divs = parentEl.getElementsByClassName("sb-widget");
        let indexes = [];
        for (let i = 0; i <= divs.length - 1; i++) {
          if(divs[i].classList.contains('filter-item')){
            indexes.push(i)
          }
        }

        $('#sidebar .sb-widget.filter-item').each(function(){
          el.append($(this))
        })
        $('#sidebar .sb-widget').eq(indexes[0] - 1).after(el);
      }
    }
  }

  ,updateSwatchValue: function(){
    if($('body').hasClass('templateProduct')){

      $('#product-info .variants-wrapper').find('.selector-wrapper select').each(function(){
        let defaultVal = $(this).val();
        let className = $(this).prev().text().toLowerCase();
        $(this).prev().append("<span class='required-star'>*</span>");

        if ($('#product-info .options .swatch').length > 0){
          $('#product-info .options .swatch[data-value="' + className + '"]').find('.header .swatch-value').text(defaultVal);

          $(this).on('change', function(){
            let newVal = $(this).val();
            $('#product-info .options .swatch[data-value="' + className + '"]').find('.header .swatch-value').text(newVal);
          })
        }
      })

    }
  }

  ,addEvent : function(obj, evt, fn){ // Exit intent
    if (obj.addEventListener) {
      obj.addEventListener(evt, fn, false);
    }
    else if (obj.attachEvent) {
      obj.attachEvent("on" + evt, fn);
    }
  }

  ,exitIntent : function(){  // Exit intent trigger
    AT_Main.addEvent(document, 'mouseout', function(evt) {

      if (evt.toElement == null && evt.relatedTarget == null ) {
        AT_Main.newsletterPopupAction();
      };

    });
  }

  ,newsletterPopupAction : function(){ // Action newsletter popup
    let expire = jQuery("#newsletter-popup").data('expires');

    if (jQuery.cookie('mycookie')) {
      //it hasn't been one days yet
    }
    else {
      $('#newsletter_popup').modal('show');
    }
    jQuery.cookie('mycookie', 'true', { expires: expire });
  }

  ,newsletterPopupDelayAction : function(){ // Action newsletter popup with delay time
    let delay = jQuery("#newsletter-popup").data('delay');
    let expire = jQuery("#newsletter-popup").data('expires');
    if (jQuery.cookie('mycookie')) {
      //it hasn't been one days yet
    }
    else {
      setTimeout(function(){
        $('#newsletter_popup').modal('show');
      }, delay);
    }
    jQuery.cookie('mycookie', 'true', { expires: expire });
  }

  ,newsletterPopup : function(){ // Show newsletter popup
    let style = jQuery("#newsletter-popup").data('style');
    if ($('.newsletter-popup-content').length > 0){
      $("#newsletter-popup").on('shopify:block:select', function(){
        $('#newsletter_popup').modal('show');
        AT_Main.init_CountDown();
      });
      $("#newsletter-popup").on('shopify:block:deselect', function(){
        $('#newsletter_popup').modal('hide');
      });

      if (style == 'delay'){
        AT_Main.newsletterPopupDelayAction();
      }

      else if (style == 'exit-intent'){
        AT_Main.exitIntent();
      }

      else{
        jQuery(window).scroll(function() {
          let scroll_position = jQuery("#newsletter-popup").data('scroll');
          let newsletter_st = jQuery(this).scrollTop();

          if (newsletter_st > scroll_position ) {
            AT_Main.newsletterPopupAction();
          }
        });
      }

      jQuery('.np-close').on('click',function (e) {
        $('#newsletter_popup').modal('hide');
      })
    }
    else {return ;}
  }

  ,newsletterCoupon: function(){ // Show coupon code when subscribe newsletter

    jQuery('#mc-button').on('click', function (event) {
      if (event) event.preventDefault()
      let $form = $('#mc-form');

      jQuery.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
        success: function (data) {
          jQuery('.text-box-image').hide();
          jQuery('.subscribe-result').show();
          jQuery('.newsletter-popup-content').removeClass('block-image-true').addClass('block-image-false');
        }
      })
    })

    jQuery('.btn-copy').on('click',function (e) {
      var _temp = $('<input>');
      $("body").append($temp);
      _temp.val($('#mycode').text()).select();
      document.execCommand("copy");
      _temp.remove();
    })
  }

  ,currencies_translate_popup: function() {
    
    if($('#language-popup').attr('data-source') == '1'){
      if($('.currency_icon_desktop').attr('data-flag') == 'currency'){ 
        let _cflag = $("#language-popup .currency_wrapper .currency_code i"); 
        let _cflag_option = $(".currency-selector__dropdown").children("option:selected").val();
        let _cflag_option_lowerCase = _cflag_option.toLowerCase();
        $(".currency_icon,.currency_icon_mobile").html('<i class="currency-flag currency-flag-' + _cflag_option_lowerCase + '"/></i>');
      }
    }
    else if($('#language-popup').attr('data-source') == '2'){
      if($('.currency_icon_desktop').attr('data-flag') == 'currency'){ 
        setTimeout(function(){
          var _cflag = $("#language-popup .currency_wrapper .currency_code i"); 
          $(".currency_icon,.currency_icon_mobile").html(_cflag);
        }, 1200);
      }

      jQuery(document).on('click','.currency_wrapper',function(){	
        if ($('.currencies-dropdown').hasClass("opened")) {
          $('.currencies-dropdown').removeClass("opened");
          $(this).removeClass("icon-opened");
        } else {
          $('.currencies-dropdown').addClass("opened");
          $(this).addClass("icon-opened");
        }
      });
    }
    else{
      // to do this
    }

    $('.currency-selector select').on('change', function() {
      $(this).parents('form').submit();
    });

    jQuery(document).on('click','.disclosure_wrapper',function(){ 
      if ($('.disclosure-list').hasClass("opened")) {
        $('.disclosure-list').removeClass("opened");
        $(this).removeClass("icon-opened");
      } else {
        $('.disclosure-list').addClass("opened");
        $(this).addClass("icon-opened");
      }
    });

    if($('.currency_icon_desktop').attr('data-flag') == 'lang-list'){
      var _localeSelector = $('#LocaleSelector').val();
      if(_localeSelector == 'pt-PT' || _localeSelector == 'pt-BR'){
        _localeSelector = 'pt';
      }
      else if(_localeSelector == 'zh-CN' || _localeSelector == 'zh-TW'){
        _localeSelector = 'zh';
      }
      else{
        _localeSelector = _localeSelector;
      }
      $(".currency_icon_desktop,.currency_icon_mobile").html('<i class="language-flag language-flag-' + _localeSelector + '"/></i>');
    }

    if($('.currency_icon_desktop').attr('data-flag') == 'lang-weglot'){
      var _localeSelector = $('.wgcurrent').attr('data-l');
      $(".currency_icon_desktop,.currency_icon_mobile").html('<i class="language-flag language-flag-' + _localeSelector + '"/></i>');
    }

    $('#lang-list .disclosure-list__option').click(function() {
      var _locale_shop_url = $("input[name='lang_to']").val();
      var _locale_return_to = $("input[name='return_to']").val();
      var _locale_remove_to = '/' + $('#LocaleSelector').val();
      var _locale_link_to = _locale_return_to.replace(_locale_remove_to, '');

      if($(this).hasClass('disclosure-list__item--primary')){
        var _locale_lang = '';
        window.location.href = _locale_shop_url + _locale_lang + _locale_link_to;
      }
      else{
        var _locale_lang = $(this).attr('lang');
        window.location.href = _locale_shop_url + '/' + _locale_lang + _locale_link_to;
      } 

    })

  }

  ,openCustomerDropdown: function () {
    let trigger;
    $(document).on('click','.customer-account span',function(e){
      $('.customer-account ul').toggleClass('open');
      trigger = e.target;
    });

    $(document).on('click', function(e){
      if(e.target != trigger) {
        $('.customer-account ul').removeClass('open');
      }
    })
  }

  ,toggleViewAllVerticalMenu: function(el){
    el.find('.view-all').on('click',function(){
      el.find('li').each(function(){
        if($(this).data('hide') && $(this).attr('style') == 'display: none;'){
          $(this).slideDown();
        } 
        else if ($(this).data('hide') && ($(this).attr('style') == '' || $(this).attr('style') == 'display: list-item;')) {
          $(this).slideUp();
        }
      })

      if($(this).find('i').hasClass('icon-add')) {
        $(this).find('a').html('<i class="demo-icon icon-minus"></i>View less');
      } 
      else {
        $(this).find('a').html('<i class="demo-icon icon-add"></i>View all');
      }
    })
  }

  ,showSharingOption: function(el, _class){
    el.off('click.showSharingOption').on('click.showSharingOption', function(e) {
      if(el.hasClass('opened')) {
        el.removeClass('opened')
      } 
      else {
        el.addClass('opened'); 
      }
    })

    $(document).on('click', function(e){
      if(!e.target.classList.contains(_class))
      { 
        el.removeClass('opened');
      }
    }) 
  }

  ,handleMainPlayList: function(parentDiv, audioEl) {

    class_play = audioEl + ' #video-list-play';
    $(parentDiv + ' #play-video').click(function() {
      
      if(!$(parentDiv + ' #play-video').hasClass('hide')){
        $(parentDiv + ' #play-video').addClass('hide');
      }

      let button = $(parentDiv + ' .product-wrapper .btn-play-pause i:not(.inactive)');
      button.removeClass('icon-play');
      button.addClass('icon-pause');

      jQuery(class_play).YTPPlay();
    });

    jQuery(class_play).on("YTPPlay",function(e){
      let button = $(parentDiv + ' .product-wrapper .btn-play-pause i:not(.inactive)');
      button.removeClass('icon-play');
      button.addClass('icon-pause');

      if(!$(parentDiv + ' #play-video').hasClass('hide')){
        $(parentDiv + ' #play-video').addClass('hide');
      }
     
    });

    jQuery(class_play).on("YTPPause",function(e){
      let button = $(parentDiv + ' .product-wrapper .btn-play-pause i:not(.inactive)');
      button.removeClass('icon-pause');
      button.addClass('icon-play');
     
    });

    jQuery(class_play).on("YTPEnd",function(e){
      let button = $(parentDiv + ' .product-wrapper .btn-play-pause i:not(.inactive)');
      button.removeClass('icon-pause');
      button.addClass('icon-play');
     
    });
  }

  ,handlePlayList: function(parentDiv, productWrapper, audioEl) {
    $(parentDiv).find(productWrapper +  ' .btn-play-pause').off('click.playList').on('click.playList', function(){
      
      let link = $(this).data('link'),
          cover = $(this).data('cover'),
          playListType = $(this).parents(parentDiv).data('playlist-type'),
          dataFirst = $(this).attr('data-first');
          sectionFirst = $(parentDiv).attr('data-first');
 
      if (playListType == 'audio') {  

        $(parentDiv).find('.btn-play-pause i').each(function(index, item){
          if('#'+ $(item).parents('.product-wrapper').attr('id') != productWrapper && $(item).hasClass('icon-pause')) {
            $(item).removeClass('icon-pause');
            $(item).addClass('icon-play');
          }
        })  

        if (link != '') {
          if($(this).find('i').hasClass('icon-play')) {
            $(this).find('i').removeClass('icon-play'); 
            $(this).find('i').addClass('icon-pause');
            let prodID = $(this).data('product-id');

            $(this).parents(parentDiv).find('.product-big-image .product-image').each(function(index, item){
              if($(item).data('product-id') == prodID) {
                $(item).parents('.product-wrapper').show();
                $(item).show();
              }
              else{
                $(item).parents('.product-wrapper').hide();
                $(item).hide();
              }
            });

            $(this).parents(parentDiv).find('.product-big-image .audio-wrapper').addClass('played');
            AT_Main.changeAudio(link, audioEl);

          }
          else {
            $(this).find('i').removeClass('icon-pause');
            $(this).find('i').addClass('icon-play');

            $(this).parents(parentDiv).find('.product-big-image .audio-wrapper').removeClass('played');
            AT_Main.changeAudio('', audioEl)
          }
        } 
      } else { /* type = video*/

        if(!$(parentDiv + ' #play-video').hasClass('hide')){
          $(parentDiv + ' #play-video').addClass('hide');
        }

        $(parentDiv).find('.btn-play-pause i').each(function(index, item){
          if('#'+ $(item).parents('.product-wrapper').attr('id') != productWrapper ) {
            $(item).removeClass('icon-play icon-pause inactive');
            $(item).addClass('icon-play inactive');
          }
        })  


        if (link != '') {
          if(dataFirst == "false") {

            /*$(this).find('i').removeClass('hide'); */
            let prodID = $(this).data('product-id');

            $(this).parents(parentDiv).find('.product-big-image .product-image').each(function(index, item){
              if($(item).data('product-id') == prodID) {
                $(item).parents('.product-wrapper').show();
                $(item).show();
              }
              else{
                $(item).parents('.product-wrapper').hide();
                $(item).hide();
              }
            });
            
            class_play = audioEl + ' #video-list-play';
            
            if(sectionFirst == "true") {
              $(parentDiv).attr('data-first', 'false');
            } else {
              jQuery(class_play).YTPPlayerDestroy();
            }

            $(audioEl).html( '<div id="video-list-play" class="player video-wrapper data-property=""></div>' );
            let dataProperty = "{videoURL:'"+ link + "',containment:'" + audioEl +"', autoPlay:false,startAt:0,loop:true,opacity:1,optimizeDisplay:true,showControls:true,useOnMobile:true,anchor: 'center,center', coverImage:'"+ cover + "'}";
            $(class_play).attr('data-property', dataProperty);
            var myPlayer = jQuery(class_play).YTPlayer();
            
            AT_Main.handleMainPlayList(parentDiv, audioEl);
              
            let _this = this;
            jQuery(class_play).on("YTPReady",function(e){
              
              $(_this).find('i').removeClass('icon-play icon-pause inactive');
              $(_this).find('i').addClass('icon-play');

              $(parentDiv + ' #play-video').removeClass('hide');

            });
          
            $(parentDiv).find('.btn-play-pause').attr('data-first', 'false');
            $(parentDiv + " " + productWrapper).find('.btn-play-pause').attr('data-first', 'true');

          }
          else {
            class_play = audioEl + ' #video-list-play';
            if($(this).find('i').hasClass('icon-play')) {
              $(this).find('i').removeClass('icon-play');
              $(this).find('i').addClass('icon-pause');

              jQuery(class_play).YTPPlay();

            } else {
              $(this).find('i').removeClass('icon-pause');
              $(this).find('i').addClass('icon-play');

              jQuery(class_play).YTPPause();
            }
          }
        } else {

          $(this).parents(parentDiv).find('.product-big-image .product-image').each(function(index, item){
            if($(item).data('product-id') == prodID) {
              $(item).parents('.product-wrapper').show();
              $(item).show();
            }
            else{
              $(item).parents('.product-wrapper').hide();
              $(item).hide();
            }
          });

          class_play = audioEl + ' #video-list-play';
          $(audioEl).html( '' );
          $(this).find('i').removeClass('icon-play icon-pause inactive');
          $(this).find('i').addClass('icon-play inactive');
          
        }
      }

    })
  }

  ,changeAudio: function(song, el){
    let audio = document.getElementById(el);
    $(audio).find('source').attr('src', song);
    audio.load();
    audio.play();
  }

  ,clickfaq : function() {
    var _tagert = $('.question-faq');
    _tagert.on('click', function(e) {
      var _ques = $(this).attr('data-id');
      if($(this).hasClass('open')) {
        $(this).removeClass('open');
        $('#'+_ques).removeClass('open');
      } else {
        $('#'+_ques).addClass('open');
        $(this).addClass('open');
      }
      
      
    })
  }

  ,debounceTime : function(func, time){
    var timeout;
    return function(){
      var context = this, args = arguments;
      var excuteFn = function(){
        func.apply(context, args);
      }

      clearTimeout(timeout);
      timeout = setTimeout(excuteFn,time);
    };
  }

  ,init : function(){
    if( typeof _bc_config == 'undefined' ){
      console.log( " _bc_config is undefined " );
      return ;
    }

    this.effectNavigation();
    this.filterCatalog();
    this.fixButton();
    this.fixedHeader();
    this.fixTitle();
    this.handleGridList();
    this.handleMenuMultiLine();
    this.init_CountDown();
    this.init_handle();
    this.megamenuWithTabs(); 
    this.menuOnMobile_handle();
    this.menuOnMobile();
    this.vertical_menu_handle();
    this.productDescription();
    this.quickShop_drawerHandle();
    this.resizeCollection();
    this.slickProductPage();
    this.swatch();
    this.switchImgProduct();
    this.toTopButton();
    this.toggleCartSidebar();
    this.toggleFilterSidebar();
    this.sidebar_menu_handle();
    this.footer_handle();
    this.scareScreen();
    this.productPage_handle();
    this.toggleVerticalMenu();
    this.toggleFtMenuMobile();
    //this.groupFilterIntoParentDiv();
    this.openCustomerDropdown();
    this.clickfaq();
    this.cart_event_handle();
    ///this.updateSwatchValue();
 }
}

/* Handle when window resize */
jQuery(window).resize(AT_Main.resize_handle);

jQuery(window).on('load', AT_Main.init_onload)

jQuery(document).ready(function($) {
  AT_Main.init();

  var i_sections = new theme.Sections();
  i_sections.register('slideshow',      function(){if ( bcMsieVersion.MsieVersion() == 0 ){AT_Main.homeSlideshow();}else{AT_Main.homeIE();}});
  i_sections.register('product-listing',function(){AT_Main.init_carousel2(jQuery('.listing-block-carousel'))});
  i_sections.register('product-grid-v2',   function(){AT_Main.init_carousel2(jQuery('.ps-list'))});
  i_sections.register('product-grid',   function(){AT_Main.init_carousel2(jQuery('.ps-list'))});
  i_sections.register('product-tabs',   function(){AT_Main.init_carousel2(jQuery('.tabs-list-carousel'))});
  i_sections.register('image-gallery',  function(){AT_Main.init_masonry()});
  i_sections.register('collectionPage', function(){if(jQuery('.page-cata .top-banner').find('.top-banner-items').length > 1){AT_Main.init_carousel2(jQuery('.page-cata .top-banner'));}AT_Main.handleGridList();})
  i_sections.register('collection-list',function(){AT_Main.init_carousel2(jQuery('.collection-cs-list'))});
  i_sections.register('newsletter-popup',function(){
   AT_Main.newsletterPopup();
   AT_Main.newsletterCoupon();
  });
  i_sections.register('header',function(){
    AT_Main.header_handle();
  });
});